import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: media.ProcessErrors.
export default class ProcessError extends Fragment {
  declare [Type]: 'media/process-error';

  // personId specifies the person resource that had an error.
  @attr('string', { defaultValue: '' })
  declare personId: string;

  // heroId specifies the heroId that had an error.
  @attr('number', { defaultValue: 0 })
  declare heroId: number;

  // error specifies the type of error the process returned.
  @attr('number', { defaultValue: 0 })
  declare error: number;
}
